import dynamic from 'next/dynamic'

import {
	CHECKOUT_LAYOUT,
	CUSTOMER_CARE_LAYOUT,
	CUSTOMER_CARE_NO_SIDEBAR_LAYOUT,
	CUSTOMER_LAYOUT,
	GUEST_LAYOUT,
	LIGHT_LAYOUT,
	MAIN_LAYOUT,
	RESTRICTED_LAYOUT,
	SALES_AGENT_LAYOUT,
	WITHOUT_LAYOUT,
	ERROR_LAYOUT,
} from './variants'

import customLayoutConfig from './custom-layout-config'

const CustomerLayout = dynamic(() => import('./customer-layout/customer-layout'))
const CheckoutLayout = dynamic(() => import('@bluheadless/ui/src/layouts/checkout-layout'))
const CustomerCareLayout = dynamic(() => import('./customer-care-layout/customer-care-layout'))
const GuestLayout = dynamic(() => import('@bluheadless/ui/src/layouts/guest-layout/guest-layout'))
const MainLayout = dynamic(() => import('@bluheadless/ui/src/layouts/main-layout'))
const WithoutLayout = dynamic(() => import('@bluheadless/ui/src/layouts/without-layout/without-layout'))
const LightLayout = dynamic(() => import('@bluheadless/ui/src/layouts/light-layout'))
const SalesAgentLayout = dynamic(() => import('@bluheadless/ui/src/layouts/sales-agent-layout/sales-agent-layout'))
const ErrorLayout = dynamic(() => import('@bluheadless/ui/src/layouts/error-layout/error-layout'))

const layoutConfig = {
	[MAIN_LAYOUT]: MainLayout,
	[CHECKOUT_LAYOUT]: CheckoutLayout,
	[CUSTOMER_LAYOUT]: CustomerLayout,
	[CUSTOMER_CARE_LAYOUT]: CustomerCareLayout,
	[CUSTOMER_CARE_NO_SIDEBAR_LAYOUT]: CustomerCareLayout,
	[GUEST_LAYOUT]: GuestLayout,
	[WITHOUT_LAYOUT]: WithoutLayout,
	[LIGHT_LAYOUT]: LightLayout,
	[RESTRICTED_LAYOUT]: LightLayout,
	[SALES_AGENT_LAYOUT]: SalesAgentLayout,
	[ERROR_LAYOUT]: ErrorLayout,
	...customLayoutConfig,
}

export default layoutConfig
